import { DataResult } from '@progress/kendo-data-query';
import { GridExpandChangeEvent } from '@progress/kendo-react-grid';
import { useCallback, useState } from 'react';

export function useGridWithExpansion() {
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const onExpandChange = useCallback(
    (event: GridExpandChangeEvent) => {
      const item = event.dataItem;
      if (item.key) {
        const newCollapsedIds = !collapsedState.includes(item.key)
          ? [...collapsedState, item.key]
          : collapsedState.filter((groupId: string) => groupId !== item.key);
        setCollapsedState(newCollapsedIds);
      }
    },
    [collapsedState]
  );

  const mapExpansionToData = useCallback(
    (gridResult: DataResult) => {
      const transformRow = (row: any): any => {
        const transformedRow = {
          ...row,
          expanded: !collapsedState.includes(row.key),
        };

        // If the row contains nested data, apply transformation recursively
        if (row.hasSubgroups) {
          return {
            ...transformedRow,
            items: transformedRow.items.map(transformRow),
          };
        }

        return transformedRow;
      };

      const result = {
        ...gridResult,
        data: gridResult.data.map(transformRow),
      };
      return result;
    },
    [collapsedState]
  );
  return { collapsedState, onExpandChange, mapExpansionToData };
}
